import React, { forwardRef, useState } from 'react';
import reportslogo from "../../assets/images/reportslogo.png";
import "../../assets/css/assetreport.css";
import "../../assets/css/reports.css";
import { DefaultCard } from "../../assets/styled-components/card";
import Kpiresponsechart from './Kpiresponsechart';
import "../../assets/css/reports.css";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { defaultLightTheme } from "../../assets/styled-components/themes/themelist";
import { useSelector } from "react-redux";
const Kpiresponsereport = forwardRef((props, ref) => {
    const { reportdata, className, hospitalname, year, service, options, setText, text, date, setDate } = props;
    const { mode } = useSelector((state) => state.theme);

    const handleText = (field, value) => {
        setDate((prev) => ({ ...prev, [field]: value }));
    };
    function parsePercentage(value) {
        return typeof value === 'string' && value.includes('%')
            ? parseFloat(value.replace('%', ''))
            : parseFloat(value) || 0;
    }


    const data = [
        parsePercentage(reportdata?.perJan),
        parsePercentage(reportdata?.perFeb),
        parsePercentage(reportdata?.perMarch),
        parsePercentage(reportdata?.perApril),
        parsePercentage(reportdata?.perMay),
        parsePercentage(reportdata?.perJune),
        parsePercentage(reportdata?.perJuly),
        parsePercentage(reportdata?.perAugust),
        parsePercentage(reportdata?.perSept),
        parsePercentage(reportdata?.perOct),
        parsePercentage(reportdata?.perNov),
        parsePercentage(reportdata?.perDec)
    ];


    const filteredData = data.filter(value => value > 0);

    const chartData = {
        labels: [
            `Jan-${year}`, `Feb-${year}`, `Mar-${year}`, `Apr-${year}`, `May-${year}`, `Jun-${year}`,
            `Jul-${year}`, `Aug-${year}`, `Sep-${year}`, `Oct-${year}`, `Nov-${year}`, `Dec-${year}`
        ],
        datasets: [
            {
                label: 'Result',
                data: data,
                borderColor: 'rgb(75, 192, 192)',
                backgroundColor: 'rgb(75, 192, 192)',
                fill: true,
            },
            {
                label: 'Target',
                data: Array(12).fill(100),
                borderColor: 'rgb(255, 99, 132)',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                fill: true,
            },
            {
                label: 'Trendline(Result)',
                data: calculateLinearTrendline(filteredData),
                borderColor: 'rgba(54, 162, 235, 1)',
                borderDash: [10, 5],
                pointRadius: 0,
                fill: false,
                tension: 0.4,
            }
        ],
    };

    const option = {
        scales: {
            y: {
                beginAtZero: true,
                max: 120,
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    title: function (context) {
                        const datasetLabel = context[0].dataset.label;
                        return `Series: ${datasetLabel}`;
                    },
                    label: function (context) {
                        const pointLabel = context.label || '';
                        const value = context.raw || 0;
                        const formattedValue = `${value}%`;

                        if (context.dataset.label === "Target") {
                            return `${pointLabel}, Value: ${formattedValue} - Target Plot`;
                        } else if (context.dataset.label === "Result") {
                            return `${pointLabel}, Value: ${formattedValue} - Result Plot`;
                        }
                        return `${pointLabel}, Value: ${formattedValue}`;
                    },
                },
            },
        },
    };


    function calculateLinearTrendline(data) {
        const n = data.length;
        const sumX = data.reduce((acc, _, i) => acc + i, 0);
        const sumY = data.reduce((acc, y) => acc + y, 0);
        const sumXY = data.reduce((acc, y, i) => acc + i * y, 0);
        const sumXX = data.reduce((acc, _, i) => acc + i * i, 0);

        const slope = (n * sumXY - sumX * sumY) / (n * sumXX - sumX * sumX);
        const intercept = (sumY - slope * sumX) / n;


        return data.map((_, i) => slope * i + intercept);
    }


    return (
        // <MuiThemeProvider
        //     theme={{
        //         ...defaultLightTheme,
        //         palette: {
        //             ...defaultLightTheme.palette,
        //             background: {
        //                 default: mode !== "light" && "rgba(17, 17, 17, 1)",
        //             },
        //         },
        //     }}
        // >
        //     <CssBaseline />
        <div id="capture" className={className} ref={ref}>
            <header className="kpi-header">
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                    <div className="logo" style={{ marginRight: '16px' }}>
                        <img src={reportslogo} alt="logo" style={{ maxWidth: '100px', height: '95px' }} />
                    </div>


                    <div style={{ flexGrow: 0.5 }}></div>
                    <div style={{ textAlign: "center", marginBottom: "20px", fontFamily: "Arial Narrow", fontSize: '19px' }}>
                        <p style={{ margin: '0', fontSize: '23px', fontWeight: 'bold' }}>
                            {hospitalname?.label}

                        </p>
                        <p style={{ margin: '0', fontSize: '23px', marginTop: '8px', fontFamily: "Arial Narrow", fontWeight: 'bold' }}>
                            KEY PERFORMANCE INDICATOR - Response Time Report
                        </p>
                    </div>


                    <div style={{ flexGrow: 1 }}></div>
                </div>





            </header>
            <section className="kpi-table" style={{ display: 'table', width: '100%', borderCollapse: 'collapse' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '10px', width: '25%', fontSize: '16px' }}><strong>SERVICE STANDARD</strong></td>
                            <td style={{ padding: '10px', verticalAlign: 'top', width: '75%' }} colSpan="3">
                                <span style={{ display: 'inline-block', width: '100%', color: 'black', padding: '2px 4px', borderRadius: '4px', fontSize: '15px' }}>
                                    {service}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '10px', width: '25%', fontSize: '16px' }}><strong>MEASURABLE ELEMENT</strong></td>
                            <td style={{ padding: '10px', verticalAlign: 'top', width: '75%', backgroundColor: 'turquoise' }} colSpan="3">
                                <span style={{ display: 'inline-block', width: '100%', color: 'black', padding: '2px 4px', borderRadius: '4px', fontSize: '15px' }}>
                                    <div>
                                        <strong>
                                            Response time to equipment failure for other equipment within
                                            &nbsp;
                                            {options?.value === 1 ? (
                                                <span>2 hours</span>
                                            ) : options?.value === 2 ? (
                                                <span>15 minutes</span>
                                            ) : null}
                                            &nbsp;for {service}.

                                        </strong>
                                    </div>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '10px', width: '25%', fontSize: '16px' }}><strong>Numerator</strong></td>
                            <td style={{ padding: '10px', verticalAlign: 'top', width: '25%', fontSize: '15px', color: 'black' }}>Total cumulative number of minutes taken for response time for all incidents of equipment failure from other service areas of the Facility for the month</td>
                            <td style={{ padding: '10px', width: '25%', fontSize: '16px' }}><strong>Inclusion</strong></td>
                            <td style={{ padding: '10px', verticalAlign: 'top', width: '25%', fontSize: '15px' }}>All calls received from individual service areas of the Facility on complaints of equipment failure and the corresponding response time for each event in the month</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '10px', width: '25%', fontSize: '16px' }}><strong>Denominator</strong></td>
                            <td style={{ padding: '10px', verticalAlign: 'top', width: '25%', fontSize: '15px' }}>Total numbers of calls received from other service areas of the Facility on equipment failure for the month</td>
                            <td style={{ padding: '10px', width: '25%', fontSize: '16px' }}><strong>Exclusion</strong></td>
                            <td style={{ padding: '10px', verticalAlign: 'top', width: '25%', fontSize: '15px' }}>NA</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '10px', width: '25%', fontSize: '16px' }}><strong>Target</strong></td>
                            <td style={{ padding: '10px', verticalAlign: 'top', width: '75%', fontSize: '15px', backgroundColor: 'turquoise' }} colSpan="3">
                                <span style={{ display: 'inline-block', width: '100%', color: 'black', padding: '2px 4px', borderRadius: '4px', fontSize: '15px' }}>
                                    <div>
                                        Target for {`${options?.label}`} –
                                        {options && (
                                            <span>
                                                {options?.value === 1 && '120 minutes'}
                                                {options?.value === 2 && '15 minutes'}
                                            </span>
                                        )}
                                    </div>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </section>


            <div style={{ display: 'flex', border: '1px solid black', padding: '10px', width: '100%', backgroundColor: 'limeGreen' }}>
                <div style={{ flex: '1', padding: '10px' }}>
                    <strong>RESULTS FOR THE YEAR OF :</strong>
                </div>
                <div style={{ flex: '3', padding: '10px' }}>
                    <span style={{ display: 'inline-block', width: '100%', color: 'black', padding: '2px 4px', borderRadius: '4px' }}>
                        {year}
                    </span>
                </div>
            </div>


            <section className="results-table">
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead>
                        <tr style={{ border: '1px solid black' }}>
                            <th style={{ border: '1px solid black' }} >Year</th>
                            <th style={{ border: '1px solid black' }}>Month</th>
                            <th style={{ border: '1px solid black' }}>Jan-{year}</th>
                            <th style={{ border: '1px solid black' }}>Feb-{year}</th>
                            <th style={{ border: '1px solid black' }}>Mar-{year}</th>
                            <th style={{ border: '1px solid black' }}>Apr-{year}</th>
                            <th style={{ border: '1px solid black' }}>May-{year}</th>
                            <th style={{ border: '1px solid black' }}>Jun-{year}</th>
                            <th style={{ border: '1px solid black' }}>Jul-{year}</th>
                            <th style={{ border: '1px solid black' }}>Aug-{year}</th>
                            <th style={{ border: '1px solid black' }}>Sep-{year}</th>
                            <th style={{ border: '1px solid black' }}>Oct-{year}</th>
                            <th style={{ border: '1px solid black' }}>Nov-{year}</th>
                            <th style={{ border: '1px solid black' }}>Dec-{year}</th>
                            {/* <th style={{ border: '1px solid black' }}>Total</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        <tr style={{ border: '1px solid black' }}>
                            <td rowSpan="4" style={{ border: '1px solid black' }}>{year}</td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>Numerator</td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.nuJan !== undefined && reportdata?.nuJan !== null
                                    ? Math.round(reportdata.nuJan)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.nuFeb !== undefined && reportdata?.nuFeb !== null
                                    ? Math.round(reportdata.nuFeb)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.nuMarch !== undefined && reportdata?.nuMarch !== null
                                    ? Math.round(reportdata.nuMarch)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.nuApril !== undefined && reportdata?.nuApril !== null
                                    ? Math.round(reportdata.nuApril)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.nuMay !== undefined && reportdata?.nuMay !== null
                                    ? Math.round(reportdata.nuMay)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.nuJune !== undefined && reportdata?.nuJune !== null
                                    ? Math.round(reportdata.nuJune)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.nuJuly !== undefined && reportdata?.nuJuly !== null
                                    ? Math.round(reportdata.nuJuly)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.nuAugust !== undefined && reportdata?.nuAugust !== null
                                    ? Math.round(reportdata.nuAugust) // Rounds the value to the nearest whole number
                                    : "0"}
                            </td>

                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.nuSept !== undefined && reportdata?.nuSept !== null
                                    ? Math.round(reportdata.nuSept)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.nuOct !== undefined && reportdata?.nuOct !== null
                                    ? Math.round(reportdata.nuOct)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.nuNov !== undefined && reportdata?.nuNov !== null
                                    ? Math.round(reportdata.nuNov)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.nuDec !== undefined && reportdata?.nuDec !== null
                                    ? Math.round(reportdata.nuDec)
                                    : "0"}
                            </td>

                            {/* <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.nuTotal !== undefined && reportdata?.nuTotal !== null
                                    ? Math.round(reportdata.nuTotal)  // Round off the value to the nearest integer
                                    : "0"}
                            </td> */}

                        </tr>
                        <tr className="result-row" style={{ border: '1px solid black' }}>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>Denominator</td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.deJan !== undefined && reportdata?.deJan !== null
                                    ? Math.round(reportdata.deJan)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.deFeb !== undefined && reportdata?.deFeb !== null
                                    ? Math.round(reportdata.deFeb)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.deMarch !== undefined && reportdata?.deMarch !== null
                                    ? Math.round(reportdata.deMarch)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.deApril !== undefined && reportdata?.deApril !== null
                                    ? Math.round(reportdata.deApril)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.deMay !== undefined && reportdata?.deMay !== null
                                    ? Math.round(reportdata.deMay)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.deJune !== undefined && reportdata?.deJune !== null
                                    ? Math.round(reportdata.deJune)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.deJuly !== undefined && reportdata?.deJuly !== null
                                    ? Math.round(reportdata.deJuly)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.deAugust !== undefined && reportdata?.deAugust !== null
                                    ? Math.round(reportdata.deAugust)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.deSept !== undefined && reportdata?.deSept !== null
                                    ? Math.round(reportdata.deSept)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.deOct !== undefined && reportdata?.deOct !== null
                                    ? Math.round(reportdata.deOct)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.deNov !== undefined && reportdata?.deNov !== null
                                    ? Math.round(reportdata.deNov)
                                    : "0"}
                            </td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.deDec !== undefined && reportdata?.deDec !== null
                                    ? Math.round(reportdata.deDec)
                                    : "0"}
                            </td>
                            {/* <td style={{ border: '1px solid black', textAlign: 'right' }}>
                                {reportdata?.deTotal !== undefined && reportdata?.deTotal !== null
                                    ? Math.round(reportdata.deTotal)
                                    : "0"}
                            </td> */}

                        </tr>
                        <tr className="result-row" style={{ border: '1px solid black', backgroundColor: 'limeGreen' }}>
                            <td style={{ border: '1px solid black', textAlign: 'center' }}><strong>Result</strong></td>

                            <td style={{ border: '1px solid black', textAlign: 'right' }}>{reportdata?.perJan || "0"}</td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>{reportdata?.perFeb || "0"}</td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>{reportdata?.perMarch || "0"}</td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>{reportdata?.perApril || "0"}</td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>{reportdata?.perMay || "0"}</td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>{reportdata?.perJune || "0"}</td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>{reportdata?.perJuly || "0"}</td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>{reportdata?.perAugust || "0"}</td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>{reportdata?.perSept || "0"}</td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>{reportdata?.perOct || "0"}</td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>{reportdata?.perNov || "0"}</td>
                            <td style={{ border: '1px solid black', textAlign: 'right' }}>{reportdata?.perDec || "0"}</td>
                            {/* <td style={{ border: '1px solid black', textAlign: 'right' }}><strong>{reportdata?.perTotal || "0"}</strong></td> */}
                        </tr>
                    </tbody>
                </table>
            </section>
            <Kpiresponsechart chartData={chartData} option={option} />
            <br></br>
            <div style={{ border: 'none', padding: '10px', fontFamily: 'Times New Roman', width: '100%' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <tbody>

                        <td colSpan="4" style={{ padding: '5px', border: 'none' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>

                                <div style={{ border: '2px solid black', flex: '1', width: '100px', height: '220px', flexDirection: 'column', marginRight: '10px' }}>
                                    <div style={{ borderBottom: '2px solid black', flexGrow: 1, display: 'flex' }}>
                                        <strong style={{ padding: '10px' }}>ANALYSIS</strong>
                                    </div>
                                    <div style={{ margin: '5px', color: 'black', height: "77%", }}>
                                        <textarea
                                            style={{
                                                outline: 'none',
                                                padding: '3px',
                                                width: '100%',
                                                height: "100%",
                                                resize: 'none',
                                                overflowWrap: 'break-word',
                                                wordWrap: 'break-word',
                                                whiteSpace: 'pre-wrap',
                                                border: 'none',
                                            }}
                                            value={text.analysis}
                                            onChange={(e) => {
                                                if (e.target.value.length <= 500) {
                                                    setText((prev) => ({
                                                        ...prev,
                                                        analysis: e.target.value,
                                                    }));
                                                }
                                            }}
                                        />
                                    </div>
                                </div>


                                <div style={{ border: '2px solid black', flex: '1', width: '100px', height: '220px', flexDirection: 'column' }}>
                                    <div style={{ borderBottom: '2px solid black', flexGrow: 1, display: 'flex' }}>
                                        <strong style={{ padding: '10px' }}>IMMEDIATE ACTION TAKEN</strong>
                                    </div>
                                    <div style={{ margin: '5px', color: 'black', height: "77%", }}>
                                        <textarea
                                            style={{
                                                display: 'block',
                                                outline: 'none',
                                                padding: '3px',
                                                width: '100%',
                                                height: "100%",
                                                resize: 'none',
                                                overflowWrap: 'break-word',
                                                wordWrap: 'break-word',
                                                whiteSpace: 'pre-wrap',
                                                border: 'none',
                                            }}
                                            value={text.immediateAction}
                                            onChange={(e) => {
                                                if (e.target.value.length <= 500) {
                                                    setText((prev) => ({
                                                        ...prev,
                                                        immediateAction: e.target.value,
                                                    }));
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                        </td>


                    </tbody>
                </table>
            </div>
            <div style={{ border: 'none', padding: '10px', fontFamily: 'Arial, sans-serif', width: '100%' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <tbody>

                        <td colSpan="4" style={{ padding: '5px', border: 'none' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                {/* <div style={{ border: '2px solid black', padding: '15px', flex: '1', marginRight: '10px', width: '100px', height: '220px' }}> */}
                                <div style={{ border: '2px solid black', flex: '1', width: '100px', height: '220px', flexDirection: 'column', marginRight: '10px' }}>
                                    <div style={{ borderBottom: '2px solid black', flexGrow: 1, display: 'flex' }}>
                                        <strong style={{ padding: '10px' }}>QUALITY IMPROVEMENT ACTIVITIES</strong>
                                    </div>
                                    <div style={{ margin: '5px', color: 'black', height: "77%" }}>
                                        <textarea
                                            style={{
                                                outline: 'none',
                                                padding: '3px',
                                                width: '100%',
                                                height: "100%",
                                                resize: 'none',
                                                overflowWrap: 'break-word',
                                                wordWrap: 'break-word',
                                                whiteSpace: 'pre-wrap',
                                                border: 'none',
                                            }}
                                            value={text.qualityImprovement}
                                            onChange={(e) => {
                                                if (e.target.value.length <= 500) {
                                                    setText((prev) => ({
                                                        ...prev,
                                                        qualityImprovement: e.target.value,
                                                    }));
                                                }
                                            }}
                                        />
                                    </div>
                                </div>


                                <div style={{ border: 'none', flex: '1', width: '100px', height: '220px', flexDirection: 'column' }}>

                                    <tbody>
                                        <tr>




                                            <table style={{ width: '100%', height: '220px', borderCollapse: 'collapse', textAlign: 'center', border: '2px solid black' }}>
                                                <thead>
                                                    <tr style={{ border: '1px solid black' }}>
                                                        <th style={{ border: '1px solid black', padding: '5px' }}>Prepared by</th>
                                                        <th style={{ border: '1px solid black', padding: '5px' }}>Reviewed by</th>
                                                        <th style={{ border: '1px solid black', padding: '5px' }}>Approved by</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {/* <tr style={{ border: '1px solid black' }}>
                                                        <td style={{ border: '1px solid black', padding: '5px', height: '40px' }}>
                                                            <input type="text" style={{ border: 'none', outline: 'none', width: '50%', height: '30px' }} />
                                                        </td>
                                                        <td style={{ border: '1px solid black', padding: '5px', height: '40px' }}>
                                                            <input type="text" style={{ border: 'none', outline: 'none', width: '50%', height: '30px' }} />
                                                        </td>
                                                        <td style={{ border: '1px solid black', padding: '5px', height: '40px' }}>
                                                            <input type="text" style={{ border: 'none', outline: 'none', width: '50%', height: '30px' }} />
                                                        </td>
                                                    </tr> */}
                                                    <tr style={{ border: '1px solid black' }}>

                                                        <td style={{ border: '1px solid black', padding: '5px', textAlign: 'left' }}>
                                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                <div style={{ marginBottom: '5px' }}>
                                                                    <label style={{ marginRight: '1px', fontWeight: 'bold', fontSize: '13px' }}>Name:</label>
                                                                    <input type="text" style={{ border: 'none', outline: 'none' }} value={date.name}
                                                                        onInput={(e) => handleText("name", e.target.value)} />
                                                                </div>
                                                                <div>
                                                                    <label style={{ marginRight: '1px', fontWeight: 'bold', fontSize: '13px' }}>Designation:</label>
                                                                    <input type="text" style={{ border: 'none', outline: 'none' }} value={date.designation} onInput={(e) => handleText("designation", e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td style={{ border: '1px solid black', padding: '5px', textAlign: 'left' }}>
                                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                <div style={{ marginBottom: '5px' }}>
                                                                    <label style={{ marginRight: '1px', fontWeight: 'bold', fontSize: '13px' }}>Name:</label>
                                                                    <input type="text" style={{ border: 'none', outline: 'none' }} value={date.names} onInput={(e) => handleText("names", e.target.value)} />
                                                                </div>
                                                                <div>
                                                                    <label style={{ marginRight: '1px', fontWeight: 'bold', fontSize: '13px' }}>Designation:</label>
                                                                    <input type="text" style={{ border: 'none', outline: 'none' }} value={date.designations} onInput={(e) => handleText("designations", e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td style={{ border: '1px solid black', padding: '5px', textAlign: 'left' }}>
                                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                <div style={{ marginBottom: '5px' }}>
                                                                    <label style={{ marginRight: '1px', fontWeight: 'bold', fontSize: '13px' }}>Name:</label>
                                                                    <input type="text" style={{ border: 'none', outline: 'none' }} value={date.nam} onInput={(e) => handleText("nam", e.target.value)} />
                                                                </div>
                                                                <div>
                                                                    <label style={{ marginRight: '1px', fontWeight: 'bold', fontSize: '13px' }}>Designation:</label>
                                                                    <input type="text" style={{ border: 'none', outline: 'none' }} value={date.designatio} onInput={(e) => handleText("designatio", e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr style={{ border: "1px solid black" }}>
                                                        {["date", "dates", "dat"].map((key) => (
                                                            <td key={key} style={{ border: "1px solid black", padding: "10px", textAlign: "left" }}>
                                                                <label style={{ marginRight: "3px", fontWeight: "bold", fontSize: "15px" }}>Date:</label>
                                                                <input
                                                                    type="text"
                                                                    style={{ border: "none", outline: "none", width: "50%" }}
                                                                    value={date[key]}
                                                                    onChange={(e) => {
                                                                        let inputValue = e.target.value;

                                                                        // Allow only numbers and slashes (/), removing any invalid characters
                                                                        let sanitizedValue = inputValue.replace(/[^0-9/]/g, "");

                                                                        // Ensure partial valid format (DD/MM/YYYY or partial valid input)
                                                                        if (/^\d{0,2}\/?\d{0,2}\/?\d{0,4}$/.test(sanitizedValue)) {
                                                                            handleText(key, sanitizedValue);
                                                                        }
                                                                    }}
                                                                    onBlur={(e) => {
                                                                        let inputValue = e.target.value;

                                                                        // Only clear if the input is completely invalid, otherwise keep it
                                                                        if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(inputValue) && inputValue.length > 0) {
                                                                            handleText(key, inputValue); // Keep input if partially valid
                                                                        }
                                                                    }}
                                                                    maxLength={10}
                                                                />
                                                            </td>
                                                        ))}
                                                    </tr>


                                                </tbody>
                                            </table>



                                        </tr>
                                    </tbody>


                                </div>
                            </div>

                        </td>


                    </tbody>
                </table>
            </div>

        </div>

    );
});

export default Kpiresponsereport;
